import { DistributionChannelListItem } from '../../../integrated-client/models/';

export type DistributionChannelList = Array<DistributionChannelListItem>;

export class ResultsData {

  items: DistributionChannelList
  showMore: boolean
  total?: number

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}